import {
    Button,
    Col,
    DatePicker,
    Form,
    Input,
    InputNumber,
    Row,
    Select,
    TimePicker,
    Typography
} from "antd";
import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { getAllOvertime, takeToil, getToilData } from "../../redux/rtk/features/overtime/overtimeSlice";
import { loadAllStaff } from "../../redux/rtk/features/user/userSlice";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";
import getUserFromToken from "../../utils/getUserFromToken";
import getPermissions from "../../utils/getPermissions";

const { TextArea } = Input;
const { Title } = Typography;

const AddToil = ({ drawer, validityId, onToilAdded, onUserSelected }) => {
    const [form] = Form.useForm();
    const [loader, setLoader] = useState(false);
    const [toilLoggedDate, setToilLoggedDate] = useState({ date: null, time: null });
    const [toilTakenDate, setToilTakenDate] = useState({ date: null, time: null });
    const [rewardType, setRewardType] = useState("Toil");
    const [overtimeLength, setOvertimeLength] = useState("0 Hours 0 Mins");
    const staffList = useSelector((state) => state.users?.list);
    const dispatch = useDispatch();
    const userId = getUserFromToken();
    const permissions = getPermissions();
    const hasPermission = (item) => {
        return permissions?.includes(item ? item : "");
    };

    useEffect(() => {
        dispatch(loadAllStaff({ status: true }));
    }, [dispatch]);

    const calculateOvertimeLength = () => {
        if (toilLoggedDate.date && toilLoggedDate.time && toilTakenDate.date && toilTakenDate.time) {
            const startDateTime = new Date(
                Date.UTC(
                    toilLoggedDate.date.split('-')[0],
                    toilLoggedDate.date.split('-')[1] - 1,
                    toilLoggedDate.date.split('-')[2],
                    ...toilLoggedDate.time.split(':').map(Number)
                )
            );
            const endDateTime = new Date(
                Date.UTC(
                    toilTakenDate.date.split('-')[0],
                    toilTakenDate.date.split('-')[1] - 1,
                    toilTakenDate.date.split('-')[2],
                    ...toilTakenDate.time.split(':').map(Number)
                )
            );
            const diffMs = Math.abs(endDateTime - startDateTime);
            const diffHrs = Math.floor(diffMs / (1000 * 60 * 60));
            const diffMins = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
            setOvertimeLength(`${diffHrs} Hours ${diffMins} Mins`);
        }
    };

    useEffect(() => {
        calculateOvertimeLength();
    }, [toilLoggedDate, toilTakenDate]);

    const handleFormSubmit = (values) => {
        console.log("AddToil - handleFormSubmit called with values:", values);
        const rewardTypeValue = rewardType === "Toil" ? false : true;
        const formData = {
            ...values,
            userId: hasPermission("readAll-user") ? values.userId : userId,
            toilLoggedDate: toilLoggedDate.date && toilLoggedDate.time
                ? new Date(Date.UTC(
                    toilLoggedDate.date.split('-')[0],
                    toilLoggedDate.date.split('-')[1] - 1,
                    toilLoggedDate.date.split('-')[2],
                    ...toilLoggedDate.time.split(':').map(Number)
                ))
                : null,
            toilTakenDate: toilTakenDate.date && toilTakenDate.time
                ? new Date(Date.UTC(
                    toilTakenDate.date.split('-')[0],
                    toilTakenDate.date.split('-')[1] - 1,
                    toilTakenDate.date.split('-')[2],
                    ...toilTakenDate.time.split(':').map(Number)
                ))
                : null,
            rewardType: rewardTypeValue
        };

        setLoader(true);

        // Determine userId - capture it before async call
        const hasReadAllPermission = hasPermission("readAll-user");
        const selectedUserId = hasReadAllPermission ? values.userId : userId;
        const addedUserId = selectedUserId ? parseInt(selectedUserId) : null;
        
        console.log("AddToil - handleFormSubmit values:", values);
        console.log("AddToil - hasReadAllPermission:", hasReadAllPermission);
        console.log("AddToil - values.userId:", values.userId, "type:", typeof values.userId);
        console.log("AddToil - logged-in userId:", userId, "type:", typeof userId);
        console.log("AddToil - selectedUserId:", selectedUserId);
        console.log("AddToil - addedUserId (parsed):", addedUserId);
        console.log("AddToil - onToilAdded callback exists:", !!onToilAdded);
        console.log("AddToil - Will call callback:", !!(onToilAdded && addedUserId));
        
        dispatch(takeToil(formData))
            .unwrap()
            .then(() => {
                console.log("AddToil - takeToil successful");
                setLoader(false);
                form.resetFields();
                dispatch(getAllOvertime());
                dispatch(getToilData()); // Refresh TOIL data
                setToilLoggedDate({ date: null, time: null });
                setToilTakenDate({ date: null, time: null });
                
                // Notify parent component about the userId for which TOIL was added
                if (onToilAdded && addedUserId) {
                    console.log("AddToil - Calling onToilAdded with userId:", addedUserId);
                    onToilAdded(addedUserId);
                } else {
                    console.log("AddToil - NOT calling onToilAdded");
                    console.log("  - onToilAdded exists:", !!onToilAdded);
                    console.log("  - addedUserId:", addedUserId);
                }
            })
            .catch((error) => {
                console.log("AddToil - takeToil error:", error);
                setLoader(false);
                toast.error("Error in logging overtime");
                // Still try to call callback even on error if we have a userId
                if (onToilAdded && addedUserId) {
                    console.log("AddToil - Error occurred but calling onToilAdded with userId:", addedUserId);
                    onToilAdded(addedUserId);
                }
            });
    };

    return (
        <Fragment>
            <UserPrivateComponent permission={"create-attendance"}>
                <Row className="mb-4">

                    <Col span={24}>

                        {(toilLoggedDate.time === null || toilLoggedDate.date === null ||
                            toilTakenDate.time === null || toilTakenDate.date === null) ? (
                            <p className='text-rose-500 text-sm font-medium mb-4' style={{ textAlign: 'left' }}>
                                * Please fill Date and Time
                            </p>
                        ) : null}
                        <Form
                            form={form}
                            style={{ marginBottom: "40px" }}
                            eventKey='overtime-form'
                            name='basic'
                            layout="vertical"
                            onFinish={handleFormSubmit}
                            autoComplete='off'>
                            <div>
                                <UserPrivateComponent permission={"readAll-user"}>
                                    <Form.Item
                                        style={{ marginBottom: "10px" }}
                                        label='Employee'
                                        name='userId'
                                        rules={[
                                            {
                                                required: true,
                                                message: "Please select an employee!",
                                            },
                                        ]}>
                                        <Select 
                                            placeholder='Select Employee'
                                            showSearch 
                                            allowClear
                                            onChange={(selectedUserId) => {
                                                console.log("AddToil - User selected from dropdown:", selectedUserId, "type:", typeof selectedUserId);
                                                if (onUserSelected) {
                                                    if (selectedUserId !== undefined && selectedUserId !== null) {
                                                        // User selected a specific user
                                                        const userIdToFilter = parseInt(selectedUserId);
                                                        console.log("AddToil - Calling onUserSelected with userId:", userIdToFilter);
                                                        onUserSelected(userIdToFilter);
                                                    } else {
                                                        // User cleared the selection (selectedUserId is undefined or null)
                                                        console.log("AddToil - User cleared selection, resetting filter to null");
                                                        onUserSelected(null);
                                                    }
                                                }
                                            }}
                                            filterOption={(input, option) =>
                                                String(option.children).toLowerCase().includes(input.toLowerCase())
                                            }>
                                            {staffList?.slice()
                                                .sort((a, b) => a.firstName.localeCompare(b.firstName))
                                                .map((staff) => (
                                                    <Select.Option key={staff.id} value={staff.id}>
                                                        {staff.firstName} {staff.lastName}
                                                    </Select.Option>
                                                ))}
                                        </Select>
                                    </Form.Item>
                                </UserPrivateComponent>
                                <Form.Item
                                    style={{ marginBottom: "10px" }}
                                    label='Toil Taken'
                                    name='toilTaken'
                                >
                                    <InputNumber placeholder="Add toil Taken" />
                                </Form.Item>

                                {/* <Form.Item
                                    style={{ marginBottom: "10px" }}
                                    label='Toil Logged'
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please input toil logged time!",
                                        },
                                    ]}>
                                    <div className='flex justify-between'>
                                        <DatePicker
                                            format={"YYYY-MM-DD"}
                                            onChange={(date, dateString) =>
                                                setToilLoggedDate({ ...toilLoggedDate, date: dateString })
                                            }
                                        />
                                        <TimePicker
                                            className='ml-4'
                                            format={"HH:mm:s"}
                                            onChange={(time, timeString) =>
                                                setToilLoggedDate({ ...toilLoggedDate, time: timeString })
                                            }
                                        />
                                    </div>
                                </Form.Item> */}

                                <Form.Item
                                    style={{ marginBottom: "10px" }}
                                    label='Toil Taken'
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please input Toil Taken time!",
                                        },
                                    ]}>
                                    <div className='flex justify-between'>
                                        <DatePicker
                                            format={"YYYY-MM-DD"}
                                            onChange={(date, dateString) =>
                                                setToilTakenDate({ ...toilTakenDate, date: dateString })
                                            }
                                            showToday={false}
                                        />
                                        <TimePicker
                                            className='ml-4'
                                            format={"HH:mm"}
                                            onChange={(time, timeString) =>
                                                setToilTakenDate({ ...toilTakenDate, time: timeString })
                                            }
                                            showNow={false}
                                        />
                                    </div>
                                </Form.Item>

                                <Form.Item
                                    style={{ marginBottom: "10px" }}>
                                    <Button
                                        type='primary'
                                        size='large'
                                        htmlType='submit'
                                        block
                                        loading={loader}
                                        disabled={
                                            // toilLoggedDate.time === null ||
                                            // toilLoggedDate.date === null ||
                                            toilTakenDate.time === null ||
                                            toilTakenDate.date === null
                                        }
                                    >
                                        Apply Toil
                                    </Button>
                                </Form.Item>
                            </div>
                        </Form>
                    </Col>
                </Row>
            </UserPrivateComponent>
        </Fragment>
    );
};

export default AddToil;